angular.module('mtic')
.constant('TIMING_CONSTANTS', {
    INSTANT: 0,
    SCOPE_REFRESH_DELAY_MS: 20,
    MESSAGE_HIDE_DELAY_MS: 2000,
    PRE_DEBUG_AUTOACTION_MS: 200,
    STUDENT_DATA_REFRESH_DELAY_MS: 100,
    BEFORE_UNLOAD_DELAY_MS: 1000,
    ALERT_BOX_DEFAULT_DISPLAY_MS: 5000,
  })
  